import { render } from "./TransactionDetails.vue?vue&type=template&id=210c1bf0&scoped=true"
import script from "./TransactionDetails.vue?vue&type=script&lang=js"
export * from "./TransactionDetails.vue?vue&type=script&lang=js"

import "./TransactionDetails.vue?vue&type=style&index=0&id=210c1bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210c1bf0"]])

export default __exports__